import * as React from "react";

export function useResolvedMediaQuery(query: string) {
  const [value, setValue] = React.useState(false);
  const [isResolved, setIsResolved] = React.useState(false);

  React.useEffect(() => {
    function onChange(event: MediaQueryListEvent) {
      setValue(event.matches);
    }

    const result = matchMedia(query);
    result.addEventListener("change", onChange);
    setValue(result.matches);
    setIsResolved(true);

    return () => result.removeEventListener("change", onChange);
  }, [query]);

  return { value, isResolved };
}

export function useMediaQuery(query: string) {
  const { value } = useResolvedMediaQuery(query);

  return value;
}
